export default __webpack_public_path__ + "static/media/login-box.a851f30e.svg";